module.exports = __webpack_public_path__ + "static/media/lmbc1.982b2106.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/lmbc1.jpg
// module id = 115
// module chunks = 0